export const PERMS = {
    READ: 'user_roles.read',
    UPDATE: 'user_roles.update',
    DELETE: 'user_roles.delete',
    CREATE: 'user_roles.create',
}
